
import './DeleteInputFormsForAddFiles.scss';
import { closeDeleteInputFormsForAddFile } from '../../../adminSlice';

const DeleteInputFormsForAddFiles  = (props) => {
const {dispatch} = props;
  
 // CLICK OK
const onSend = () => {

        props.handledeleteAddFile();
}


// CLOSE FORM
const onClose = () => {
   
    dispatch(closeDeleteInputFormsForAddFile());

}


   
        return (
        
        
            
                <div className="DeleteInputFormsForAddFiles">

                    <p>Вы действительно хотите удалить файл?</p>
                    <div className='row-block'>
                        <button onClick={onSend}>Да</button>
                        <button onClick={onClose}>Отмена</button>
                    </div>
                    
                </div>
        
        
        
        
        )
       
    
}
export default DeleteInputFormsForAddFiles;